package com.milta.core.localization.translations.de

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Anmelden",
    logout = "Abmelden",
    email = "E-Mail",
    password = "Passwort",
    showPassword = "Anzeigen",
    hidePassword = "Verbergen",
    roleSelectionTitle = "Konto erstellen",
    roleSelectionSubtitle = "Wählen Sie den Kontotyp, der Ihrem Profil entspricht",
    roleDriverTitle = "Ich bin Fahrer – Zusteller",
    roleDriverDescription = "Ich fahre ein Transport- oder Lieferfahrzeug und möchte meine Touren optimieren",
    roleDriverTag1 = "Meine Touren optimieren",
    roleDriverTag2 = "Milta-Angebote auf meiner Route",
    roleEnterpriseTitle = "Ich bin ein Unternehmen",
    roleEnterpriseDescription = "Ich habe eine Umsatzsteuer-Identifikationsnummer und verwalte einen Fahrzeugpark sowie ein Fahrerteam",
    roleEnterpriseTag1 = "Flottenmanagement",
    roleEnterpriseTag2 = "Team-Nachverfolgung",
    continueButton = "Weiter",
    registerFormTitle = "Schließen Sie Ihre Registrierung ab",
    registerFormSubtitle = "Bestätigen Sie Ihre Telefonnummer, um Ihr Konto zu aktivieren.",
    registerFormSubtitleEnterprise = "Geben Sie Ihre Organisation und eine Telefonnummer an, um Ihr Konto zu aktivieren.",
    googleAccountConnected = "Google-Konto verbunden",
    appleAccountConnected = "Apple-Konto verbunden",
    firstName = "Vorname",
    lastName = "Nachname",
    phoneNumber = "Telefonnummer",
    phoneNumberHelper = "Geben Sie die Telefonnummer Ihrer Wahl ein.",
    phoneNumberOtpInfo = "Zur Bestätigung dieser Nummer wird Ihnen ein Verifizierungscode per SMS gesendet.",
    registerButton = "Verifizierungscode anfordern",
    passwordHint = "Mindestens 8 Zeichen",
    registerSuccess = "Konto erfolgreich erstellt",
    errorEmailConflict = "Diese E-Mail-Adresse wird bereits verwendet",
    errorPhoneConflict = "Diese Telefonnummer wird bereits verwendet",
    errorPhoneChangeCooldown = "Sie können Ihre Telefonnummer nur alle 30 Tage ändern",
    errorGeneric = "Verbindung fehlgeschlagen. Überprüfen Sie Ihr Netzwerk und versuchen Sie es erneut.",
    errorFirstNameRequired = "Bitte geben Sie Ihren Vornamen ein",
    errorFirstNameTooLong = "Der Vorname darf nicht länger als 100 Zeichen sein",
    errorLastNameRequired = "Bitte geben Sie Ihren Nachnamen ein",
    errorLastNameTooLong = "Der Nachname darf nicht länger als 100 Zeichen sein",
    errorPhoneTooLong = "Die Telefonnummer darf nicht länger als 20 Zeichen sein",
    errorOAuthAccountExists = "Dieses Konto ist bereits mit einem anderen Milta-Konto verknüpft. Versuchen Sie sich anzumelden.",
    errorOAuthTokenInvalid = "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    loginTitle = "Anmelden",
    loginTabPassword = "Passwort",
    loginTabPhone = "Telefonnummer",
    loginButton = "Anmelden",
    forgotPassword = "Passwort vergessen?",
    sendCodeButton = "Code senden",
    otpTitle = "Code eingeben",
    otpSubtitle = "Wir haben einen 6-stelligen Code gesendet an",
    otpVerifyButton = "Bestätigen",
    otpResend = "Code erneut senden",
    otpResendPrefix = "Code nicht erhalten?",
    otpWrongNumber = "Falsche Nummer?",
    otpModifyLink = "Bearbeiten",
    forgotPasswordTitle = "Passwort vergessen",
    forgotPasswordSubtitle = "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen zu erhalten",
    forgotPasswordButton = "Link senden",
    forgotPasswordSuccess = "Überprüfen Sie Ihren Posteingang",
    resetPasswordTitle = "Neues Passwort",
    resetPasswordSubtitle = "Wählen Sie ein neues Passwort für Ihr Konto",
    resetPasswordNewLabel = "Neues Passwort",
    resetPasswordConfirmLabel = "Passwort bestätigen",
    resetPasswordButton = "Passwort zurücksetzen",
    resetPasswordSuccess = "Passwort zurückgesetzt. Sie können sich jetzt anmelden.",
    errorPasswordTooShort = "Das Passwort muss mindestens 8 Zeichen enthalten",
    errorPasswordTooLong = "Das Passwort darf nicht länger als 128 Zeichen sein",
    errorPasswordMismatch = "Die Passwörter stimmen nicht überein",
    errorTokenInvalid = "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen. Fordern Sie einen neuen an.",
    errorEmailInvalid = "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    errorPhoneRequired = "Bitte geben Sie eine Telefonnummer ein",
    errorInvalidCredentials = "Falsche E-Mail-Adresse oder falsches Passwort. Nutzen Sie bei Bedarf „Passwort vergessen?“.",
    errorInvalidOtp = "Falscher Code. Überprüfen Sie Ihre SMS oder fordern Sie einen neuen Code an.",
    errorExpiredOtp = "Code abgelaufen. Fordern Sie einen neuen Code an.",
    errorTooManyAttempts = "Zu viele fehlgeschlagene Versuche. Versuchen Sie es in ein paar Minuten erneut.",
    errorResendLimit = "Zu viele Anfragen zum erneuten Senden. Versuchen Sie es in ein paar Minuten erneut.",
    otpResendIn = "Erneut senden in %d s",
    otpAttemptsLeft = "%d Versuche verbleibend",
    loginGreeting = "Willkommen zurück!",
    loginSubtitle = "Melden Sie sich bei Ihrem Milta-Konto an",
    loginSmsOption = "SMS-Code erhalten",
    noAccount = "Noch kein Konto?",
    signUp = "Registrieren",
    organizationName = "Name der Organisation",
    organizationNameRequired = "Bitte geben Sie den Namen der Organisation ein",
    registerNextButton = "Weiter",
    passwordConfirm = "Passwort bestätigen",
    passwordRuleUpper = "Ein Großbuchstabe",
    passwordRuleDigit = "Eine Ziffer",
    passwordRuleSpecial = "Ein Sonderzeichen",
    alreadyHaveAccount = "Sie haben bereits ein Konto — Anmelden",
)
